import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

// Routes that should NOT get trailing slash (private/non-indexable paths are fine either way,
// but we apply the redirect universally for consistency — except root and file extensions).
const EXCLUDED_PREFIXES = ["/admin", "/mi-cuenta", "/auth", "/dashboard"];

export function TrailingSlashRedirect() {
  const { pathname, search, hash } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (pathname === "/" || pathname.endsWith("/") || /\.\w+$/.test(pathname)) return;
    navigate(pathname + "/" + search + hash, { replace: true });
  }, [pathname, search, hash, navigate]);

  // Scroll to top (or to hash target) on every navigation
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.replace("#", ""));
      if (el) {
        el.scrollIntoView({ behavior: "auto" });
        return;
      }
    }
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, hash]);

  return null;
}
